import {combineReducers} from 'redux';
import usrfields from './usrfields'
import global from 'shared/src/reducers/global'

export default combineReducers({
    usrfields,
    global
})